import { Result } from "./../models/Result.model";
import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { Consultant } from "../models/Consultant.model";
import { IPublicConsultantDTO } from "../views/consultants/public-consultant-edit/interfaces";
import { EmailExistsDTO } from "../views/consultants/public-consultant-edit/interfaces/EmailExistsDTO";
@Injectable()
export class PublicConsultantService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/consultants/public";

    async getPublicInfoFromAllConsultants(queryString): Promise<Result<Array<Consultant>>> {

        const res = await this.httpClient.get(`${this.endPoint}?${queryString}`);

        return new Result<Array<Consultant>>(res.consultants, {
            totalItems: res.totalItems

        })
    }

    async getPublicInfoByConsultant(id: string): Promise<IPublicConsultantDTO> {
        let response = await this.httpClient.get(`${this.endPoint}/${id}`);
        return response;

    }

    async updateOnlyPublicFields(id:string ,consultant: any) {
        let response = await this.httpClient.patch(`${this.endPoint}/${id}`,consultant);
        return response;
    }

    async verifyIfEmailExists(email: string, id?: string): Promise<EmailExistsDTO> {
        let queryString = `email=${email}`
        if (id)
            queryString = queryString.concat(`&id=${id}`)

        return await this.httpClient.get(`${this.endPoint}/verifyemail?${queryString}`)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/public-consultant.service.ts